(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('./Service'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.Service);
        global.PropertySearch = mod.exports;
    }
})(this, function (exports, _Service) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.propertySearch = undefined;

    var _Service2 = _interopRequireDefault(_Service);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : new P(function (resolve) {
                    resolve(result.value);
                }).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    var propertySearch = exports.propertySearch = function () {
        function propertySearch(searchHost, apiKey, apiVersion, indexName) {
            var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;

            _classCallCheck(this, propertySearch);

            this.searchHost = searchHost;
            this.pageSize = pageSize;
            this.apiKey = apiKey;
            this.apiVersion = apiVersion;
            this.indexName = indexName;
        }

        _createClass(propertySearch, [{
            key: 'search',
            value: function search(criteria) {
                var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

                return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var service, body;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    service = new _Service2.default(this.searchHost, { 'api-key': this.apiKey });
                                    body = {
                                        filter: this.buildFilter(criteria),
                                        orderby: this.buildOrderBy(criteria)
                                    };

                                    if (criteria.suburb) {
                                        body.search = criteria.suburb;
                                        body.searchFields = 'address_suburb_or_town';
                                        body.searchMode = 'all';
                                    } else if (criteria.postcode) {
                                        body.search = criteria.postcode;
                                        body.searchFields = 'address_postcode';
                                        body.searchMode = 'all';
                                    } else if (criteria.accountId) {
                                        body.search = criteria.accountId;
                                        body.searchFields = 'account_id';
                                        body.searchMode = 'all';
                                    } else if (criteria.accountName) {
                                        body.search = criteria.accountName;
                                        body.searchFields = 'account_name';
                                        body.searchMode = 'all';
                                    }
                                    if (this.pageSize > 0) {
                                        body.top = this.pageSize;
                                        body.skip = pageNumber * this.pageSize;
                                        body.count = true;
                                    }
                                    _context.t0 = this;
                                    _context.next = 7;
                                    return service.post(this.url, body);

                                case 7:
                                    _context.t1 = _context.sent;
                                    return _context.abrupt('return', _context.t0.processResult.call(_context.t0, _context.t1));

                                case 9:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
            }
        }, {
            key: 'getProperty',
            value: function getProperty(id) {
                return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    var service, body;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    service = new _Service2.default(this.searchHost, { 'api-key': this.apiKey });
                                    body = {
                                        search: id,
                                        searchFields: 'default_external_id',
                                        searchMode: 'all'
                                    };
                                    _context2.t0 = this;
                                    _context2.next = 5;
                                    return service.post(this.url, body);

                                case 5:
                                    _context2.t1 = _context2.sent;
                                    return _context2.abrupt('return', _context2.t0.processResult.call(_context2.t0, _context2.t1));

                                case 7:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));
            }
        }, {
            key: 'parseCollection',
            value: function parseCollection(collection) {
                var returnCollection = [];
                if (collection == null) {
                    return null;
                }
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = collection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        returnCollection.push(JSON.parse(item));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return returnCollection;
            }
        }, {
            key: 'processResult',
            value: function processResult(res) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = res.value[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var property = _step2.value;

                        property.images = this.parseCollection(property.images);
                        property.events = this.parseCollection(property.events);
                        property.links = this.parseCollection(property.links);
                        property.floorplans = this.parseCollection(property.floorplans);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return res;
            }
        }, {
            key: 'buildFilter',
            value: function buildFilter(criteria) {
                var filter = '';
                if (criteria.listingType && criteria.listingType === 'Auction') {
                    filter = filter.append('authority_type eq \'' + criteria.listingType + '\'');
                } else if (criteria.listingType) {
                    filter = filter.append('listing_sale_or_rental eq \'' + criteria.listingType + '\'');
                }
                if (criteria.currentProperties) {
                    filter = filter.append("system_listing_state eq 'current'");
                } else {
                    filter = filter.append("system_listing_state ne 'current' and system_listing_state ne 'withdrawn' and state_date ne null and state_date ne ''");
                }
                if (criteria.bedrooms) {
                    if (criteria.bedrooms.max && criteria.bedrooms.max.toString() !== '') {
                        filter = filter.append('attributes_bedrooms le \'' + criteria.bedrooms.max + '\'');
                    }
                    if (criteria.bedrooms.min && criteria.bedrooms.min.toString() !== '') {
                        filter = filter.append('attributes_bedrooms ge \'' + criteria.bedrooms.min + '\'');
                    }
                }
                if (criteria.bathrooms) {
                    if (criteria.bathrooms.max && criteria.bathrooms.max.toString() !== '') {
                        filter = filter.append('attributes_bathrooms le \'' + criteria.bathrooms.max + '\'');
                    }
                    if (criteria.bathrooms.min && criteria.bathrooms.min.toString() !== '') {
                        filter = filter.append('attributes_bathrooms ge \'' + criteria.bathrooms.min + '\'');
                    }
                }
                if (criteria.garages) {
                    if (criteria.garages.max && criteria.garages.max.toString() !== '') {
                        filter = filter.append('attributes_garages le \'' + criteria.garages.max + '\'');
                    }
                    if (criteria.garages.min && criteria.garages.min.toString() !== '') {
                        filter = filter.append('attributes_garages ge \'' + criteria.garages.min + '\'');
                    }
                }
                if (criteria.price) {
                    if (criteria.price.max && criteria.price.max.toString() !== '') {
                        filter = filter.append('price_match le ' + criteria.price.max);
                    }
                    if (criteria.price.min && criteria.price.min.toString() !== '') {
                        filter = filter.append('price_match ge ' + criteria.price.min);
                    }
                }
                if (criteria.street) {
                    filter = filter.append('address_street eq \'' + criteria.street + '\'');
                }
                if (criteria.streetNumber) {
                    filter = filter.append('address_street_number eq \'' + criteria.streetNumber + '\'');
                }
                if (criteria.unitNumber) {
                    filter = filter.append('address_unit_number eq \'' + criteria.unitNumber + '\'');
                }
                if (criteria.openForInspection) {}
                if (criteria.agentId) {
                    filter = filter.append('(listing_agent_1_id eq \'' + criteria.agentId + '\' or listing_agent_2_id eq \'' + criteria.agentId + '\')');
                }
                if (criteria.feedStatus) {
                    filter = filter.append('feed_status eq \'' + criteria.feedStatus + '\'');
                }
                if (criteria.neFeedStatus) {
                    filter = filter.append('feed_status ne \'' + criteria.neFeedStatus + '\'');
                }
                if (criteria.propertyCategory) {
                    filter = filter.append('property_category eq \'' + criteria.propertyCategory + '\'');
                }
                if (criteria.tag) {
                    filter = filter.append('tags/any(t: t eq \'' + criteria.tag + '\')');
                }
                filter = filter.append('is_deleted eq false');
                return filter;
            }
        }, {
            key: 'buildOrderBy',
            value: function buildOrderBy(criteria) {
                if (!criteria.orderBy || criteria.orderBy.length === 0) return '';
                var result = '';
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = criteria.orderBy[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var orderBy = _step3.value;

                        result += ',' + orderBy.field + ' ' + orderBy.direction;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                return result.substring(1);
            }
        }, {
            key: 'url',
            get: function get() {
                return '/indexes/' + this.indexName + '/docs/search?api-version=' + this.apiVersion;
            }
        }]);

        return propertySearch;
    }();

    String.prototype.append = function (string) {
        if (this == '') {
            return string;
        }
        return this + ' and ' + string;
    };
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.Service = mod.exports;
    }
})(this, function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : new P(function (resolve) {
                    resolve(result.value);
                }).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    var Service = function () {
        function Service(host) {
            var customHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "application/json";

            _classCallCheck(this, Service);

            this.host = host;
            this.contentType = contentType;
            this.customHeaders = customHeaders;
            this.customHeaders["Content-Type"] = this.contentType;
            this.customHeaders = {
                "api-key": customHeaders["api-key"],
                "Content-Type": this.contentType
            };
        }

        _createClass(Service, [{
            key: "get",
            value: function get(url) {
                return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                    var response, body;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return fetch(this.host + url, { credentials: "same-origin" });

                                case 2:
                                    response = _context.sent;
                                    _context.next = 5;
                                    return response.json();

                                case 5:
                                    body = _context.sent;

                                    if (!response.ok) {
                                        _context.next = 8;
                                        break;
                                    }

                                    return _context.abrupt("return", body);

                                case 8:
                                    return _context.abrupt("return", Promise.reject(body));

                                case 9:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
            }
        }, {
            key: "put",
            value: function put(url, data) {
                return this.postput(url, data, "PUT");
            }
        }, {
            key: "post",
            value: function post(url, data) {
                return this.postput(url, data, "POST");
            }
        }, {
            key: "patch",
            value: function patch(url, data) {
                return this.postput(url, data, "PATCH");
            }
        }, {
            key: "postput",
            value: function postput(url, data, method) {
                return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
                    var response, body;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return fetch(this.host + url, {
                                        method: method,
                                        body: JSON.stringify(data),
                                        headers: new Headers(this.customHeaders)
                                    });

                                case 2:
                                    response = _context2.sent;
                                    _context2.next = 5;
                                    return response.json();

                                case 5:
                                    body = _context2.sent;

                                    if (!(response.ok === true)) {
                                        _context2.next = 8;
                                        break;
                                    }

                                    return _context2.abrupt("return", body);

                                case 8:
                                    return _context2.abrupt("return", Promise.reject(body));

                                case 9:
                                case "end":
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));
            }
        }]);

        return Service;
    }();

    exports.default = Service;
});

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// propertysearch.min.js